<template>
	<div>
		<el-card class="box-card" shadow="hover">
			<div slot="header" class="clearfix" v-if="title!=''">
				<span>{{title }}</span>
			</div>
			<div class="inputBox" v-if="isdetail==0">
				<el-form-item
					v-if="i.ishidden == 'False'"
					:class="['inputItem', i.controltype == 'textarea'? 'col12' : 'col8']"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
				<div v-if="i.controltype == 'disabled_billid' && i.ishidden == 'False'" style="display: inline-block;">
					<el-input
						:style="{ width: `${i.coltdwidth}px`}"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					></el-input><i
					  class="el-icon-edit"
					  @click="editinput(i)"
					  style="cursor:pointer;"> 
					</i>
				</div>
					<el-input
						v-if="i.controltype == 'text' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					></el-input>
					<el-input
						v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						type="text"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
					</el-input>
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@keyup.native="val => enterinput(val, i)"
					>
						<div slot="append" v-if="i.colass == 'search'&&isdetail==0" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'readonly_text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:readonly="true"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@keyup.native="val => enterinput(val, i)"
					>
						<div slot="append" v-if="i.colass == 'search'&&isdetail==0" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
						:type="i.controltype"
						v-model="i.value"
						@keyup.native="val => enterinput(val, i)"
					></el-input>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable
						remote
						reserve-keyword
						placeholder="可输入关键词搜索"
						:remote-method="val => remoteMethod(val, i)"
						:loading="loading"
						v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
					</el-select>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						v-if="i.controltype == 'select' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					</el-select>
					<!-- :style="{width:`${i.coltdwidth}px`}" -->
					<el-checkbox
						v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						:checked="i.coldefault == 1 ? true : false"
						@change="val => setcheck(val, i)"
					></el-checkbox>
		
					<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
				</el-form-item>
			
			</div>
			<div class="inputBox" v-if="isdetail==1">
				<el-form-item
					v-if="i.ishidden == 'False'"
					:class="['inputItem', i.controltype == 'textarea'? 'col12' : 'col8']"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
					<span>
						{{i.value}}
					</span>
				</el-form-item>
			</div>
		</el-card>
		<selectstockinplan ref="selectstockinplan" @setselectrow="setselectrow"></selectstockinplan>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import selectstockinplan from '@/components/stockmanager/selectstock_in_plan.vue';
export default {
	components: {
		selectstockinplan
	},
	props: {
		classname: {
			type: String,
			default:''
		},
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		}
	},
	data() {
		return{
			setlist:[],
			syscol:'',
			stockmain:'',
			showaddrwin:false,
			loading:false,
			orderinfo:{},
			storagehouse:'',//仓库
			supplier:'',//供应商
			isdetail:0
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.orderinfo!=undefined){
				this.orderinfo=param.orderinfo;
				if(this.orderinfo.stockmain!=undefined)
					this.stockmain=this.orderinfo.stockmain;
			}
			//debugger
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			this.storagename='';
			this.setlist=[];
			this.getsetlist();
		},
		getsetlist(){
			var that=this;
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.l_mode}).then(res => {
				if(res.length>0){
					res.forEach(e=>{
						if(e.controltype.indexOf('disabled')>-1)
							e.isedit=true;
						else
							e.isedit=false;
					});
					if(that.setlist.length>0)
						that.setlist=that.setlist.concat(res);
					else
						that.setlist=res;
						
					if(that.stockmain!=''){
						that.setlist.forEach(item => {
							for(var i in that.stockmain){
								if(item.colname==i){
									item.value=that.stockmain[i];
									if(item.colname=='p_bagid'){
										that.storagehouse=item.value;
										that.setvalue('storagehouse',item.value);
									}
									if(item.colname=='p_airwaybill'){
										that.supplier=item.value;
										that.setvalue('supplier',item.value);
									}
								}
								if(item.colname=='p_sys')
								{
									if(item.value==''){
										if(item.coldefault!='')
											item.value=item.coldefault;
									}
								}
							}
						});
					}
					else{
						that.setlist.forEach(item => {
							if(item.controltype=='disabled_billid') 
								item.coldefault=new Date().getTime();
							if(item.coldefault!='')
								item.value=item.coldefault;
						});
					}
				}
			});
		},
		enterinput(event, i) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid'){
							if(this.$refs.cargo!=undefined)
								this.$refs.cargo[0].setgridfoucs();
							else{
								
							}
						}
						else{
							if(i.ishidden=='False'){
								this.$refs[i.colnext][0].focus();
							}
						}
					}
				} else if (event.keyCode == 37) {
					if(i.ishidden=='False'){
						if (i.colperv != '') this.$refs[i.colperv][0].focus();
					}
				}
			}
		},
		getfocuscontrol(colindex,type){
			var col='';
			if(type=='next'){
				col=this.setlist[colindex+1].colnext;
			}
			else{
				col=this.setlist[colindex-1].colperv;
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		checkinput(event,i){
			//debugger
			if(i.colname=='p_bagid'){
				this.setvalue('storagehouse',i.value);
			}
			if(i.colname=='p_airwaybill'){
				this.setvalue('supplier',i.value);
			}
		},
		//下拉选项联动
		remoteMethod(val,i) {
			var that = this;
			//debugger
			if(i.colevent=='customer'){
				var search = {
					searchbox: val,
					c_type:i.colfun
				};
				this.$tool.customerlink(this, search, '',i);
			}
			else{
				if(i.colevent!=''){
					var search={};
					search.searchbox=val;
					search.searchcol=i.colass;
					this.$tool.GetSelectData(this,i.colevent,i.colfun,search).then(res => {
						//debugger
						i.colsource=res;
					});
				}
			}
		},
		setvalue(data,value){
			//debugger
			this.$emit('setvalue',{data:data,value:value});
		},
		//带搜索的输入框
		inputgroupsearch(i,index) {
			if(i.colevent=='stock_in_plan'){
				//打开计划单列表
				if (this.$refs.selectstockinplan != undefined) this.$refs.selectstockinplan.init({selectsingle:true});
			}
		},
		setselectrow(e){
			this.$emit('setselectrow',{
				billid:e.rows[0].billid,
				type:e.type
			});
		},
		resetBillid(){
			this.setlist.forEach(item => {
				if(item.controltype=='disabled_billid') {
					item.value=new Date().getTime();
				}
				if(item.colname=='sendtype')
				 item.value='';
			});
		},
		editinput(i){
			i.isedit=false;
			var that=this;
			this.$nextTick(function() {
				that.$refs[i.colname][0].focus();
			});
		},
		//下拉选项change事件
		selectchange(val,i){
			//debugger
		}
	}
}
</script>

<style>
</style>
